export enum Transformation {
  Thumbnail = 'tr:n-thumbnail', // tr:w-144,h-144
  Content = 'tr:w-930', // tr:w-680
  ContentThumbnail = 'tr:h-64', // tr:w-680
}
